import { endpoints } from './../../../environments/environment';
import { Receipt, ReceiptType } from './models/receipt';
import { Injectable } from '@angular/core';
import { Auth } from '../../autentication/Auth';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { FormatPricePipe } from '../../shared/format-price.pipe';
import { Detail } from './models/details';
import { CpfCnpjPipe } from '../../shared/cpf-cnpj.pipe';
import { AccountNumberPipe } from '../../shared/account-number.pipe';
import { Util } from '../../utils/util';

@Injectable()
export class ReceiptsService {

	receipt: Array<Receipt>;

	receiptDetail: Detail;
	selectedReceipt: Detail;

	constructor(private http: HttpClient) { }

	getReceiptsList(dateBegin: any, dateEnd: any): Observable<Receipt[]> {

		const beginDate = moment(dateBegin).format('YYYY-MM-DD');
		const endDate = dateEnd ? moment(dateEnd).format('YYYY-MM-DD') : null;

		const params = endDate ?
			new HttpParams().set('dataInicio', beginDate).set('dataFim', endDate) :
			new HttpParams().set('dataInicio', beginDate);

		return this.http.get( endpoints.receipts.allV2, {params}).pipe(map((data: any) => {

			if (data.Sucesso) {

				if (data.Retorno !== undefined ) {
					this.receipt = data.Retorno.map(item => {
						const list = new Receipt();
						const FP = new FormatPricePipe();

						if (item.Favorecido) {
							list.receiptDescription = '- ' + item.Favorecido;
						}

						list.receiptId = item.IdComprovante;

						switch (item.TipoComprovante) {
							case 'EntreContas':
								list.receiptLabel = 'Transferência Entre Contas';
								break;
							case 'Convenio':
								list.receiptLabel = 'Convênio';
								break;
							case 'PIX':
								list.receiptLabel = 'Pagamento Pix';
								break;
							case 'PIXDevolvido':
								list.receiptLabel = 'Devolução Pix';
								break;
							default:
								list.receiptLabel = item.TipoComprovante;
								break;
						}

						list.receiptType = item.TipoComprovante as ReceiptType;
						list.date = moment(item.Data).format('DD/MM/YYYY');
						list.value = FP.transform(item.Valor, false);
						list.transactionId = item.CodigoTransacao;
						list.newReceipt = item.UsaNovoComprovante;

						return list;
					});
				} else {
					this.receipt = data.Retorno;
				}

			}

			return this.receipt;

		}));
	}

	getReceiptsDetail(idReceipt: any, typeReceipt: any, idtransaction: any, newReceipt: boolean): Observable<Detail> {
		if (
			typeReceipt === ReceiptType.PIX ||
			typeReceipt === ReceiptType.PIX_DEVOLVIDO ||
		  	([ReceiptType.BOLETO, ReceiptType.Convenio, ReceiptType.TED, ReceiptType.DOC, ReceiptType.ENTRECONTAS].includes(typeReceipt) && newReceipt)
		) {
			return this.http.get ( endpoints.bankStatement.detail + '?codigoTransacao=' + idtransaction ).pipe(map((data: any) => {

				let detail = new Detail();

				if (!data.Sucesso){
					return;
				}

				if (typeReceipt === 'PIX' || typeReceipt === 'PIXDevolvido') {
					detail = this.getReceiptDetailsPix(data, typeReceipt);
				}

				if ([ReceiptType.TED, ReceiptType.DOC, ReceiptType.ENTRECONTAS].includes(typeReceipt)) {
					detail = this.getReceiptDetailsTransfer(typeReceipt, data);
				}

				if (typeReceipt === 'Boleto' && newReceipt) {

					detail = this.getReceiptDetailsBankSlip(typeReceipt, data);
				}

				if (typeReceipt === 'Convenio' && newReceipt) {
					detail = this.getReceiptDetailsConvenioBankSlip(typeReceipt, data);
				}
				this.setSelectedReceipt(detail);

				return detail;
			}));
		}

		return this.http.get( endpoints.receipts.detail +
			typeReceipt + '/' + idReceipt ).pipe(map((data: any) => {

			const detail = new Detail();
			const FP = new FormatPricePipe();
			const CP = new CpfCnpjPipe();
			const ANP = new AccountNumberPipe();
			const item = data.Retorno;
			let itemDetalhe;

			if (data.Sucesso) {

				if (data.Retorno.DetalheTED) {
					itemDetalhe = data.Retorno.DetalheTED;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de transferência TED';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheDOC) {
					itemDetalhe = data.Retorno.DetalheDOC;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de transferência DOC';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheBoleto) {
					itemDetalhe = data.Retorno.DetalheBoleto;
					detail.favBankDescription = itemDetalhe.FavBancoDesc;
					detail.receiptsTitle = 'Comprovante de pagamento - Título para outros bancos';
					detail.receiptsSubtitle = 'Dados do boleto';
					detail.codeBar = itemDetalhe.LinhaDigitavel;
				} else if (data.Retorno.DetalheEntreContas) {
					itemDetalhe = data.Retorno.DetalheEntreContas;
					detail.receiptsTitle = 'Comprovante de transferência entre contas';
					detail.receiptsSubtitle = 'Dados da transferência';
					detail.transferEmitBankDescription = data.Retorno.TitularBanco;
					detail.favBankDescription = '613 - Omni Banco';
					detail.transferEmitAgency = itemDetalhe.EmitAgencia;
					detail.transferEmitNumberAccount = itemDetalhe.EmitNroConta;
					detail.transferEmitName = data.Retorno.NomeTitular;
				} else if (data.Retorno.DetalheConvenio) {
					itemDetalhe = data.Retorno.DetalheConvenio;
					detail.receiptsTitle = 'Comprovante de pagamento - Convênio';
					detail.receiptsSubtitle = 'Dados do boleto';
					detail.codeBar = itemDetalhe.CodBarras;
				} else if(data.Retorno.DetalheRecarga){
					itemDetalhe = data.Retorno.DetalheRecarga;
					detail.receiptsTitle = 'Comprovante de recarga';
					detail.debitDate = moment(data.Retorno.DataDebito).format('DD/MM/YYYY HH:mm');
					detail.value = FP.transform(data.Retorno.Valor, false);

					detail.payerName = Auth.getInstance().getUser().name;
					detail.payerAgency = Auth.getInstance().getUser().agency;
					detail.payerAccount = ANP.transform(Auth.getInstance().getUser().accountNumber);

					detail.transactionId = itemDetalhe.CodigoEpay;

					detail.cellphoneNumber = Util.formatPhone(itemDetalhe.Telefone.toString());
					detail.cellphoneOperator = itemDetalhe.Operadora;
				}

				if (itemDetalhe.DtVcto !== undefined) {
					detail.dueDate = moment(itemDetalhe.DtVcto).format('DD/MM/YYYY');
				}
				if (item.DataDebito !== undefined) {
					detail.debitDate = moment(item.DataDebito).format('DD/MM/YYYY');
				}
				if (item.DataHoraTransacao !== undefined) {
					detail.dateTimeTransaction = moment(item.DataHoraTransacao).format('DD/MM/YYYY [as] HH:mm:ss[h]');
				}
				detail.number = item.Numero;
				if (item.Valor !== undefined) {
					detail.value = FP.transform(item.Valor, false);
				}
				if (itemDetalhe.FavCPFCNPJ !== undefined) {
					detail.favCpfCnpj = CP.transform((itemDetalhe.FavCPFCNPJ).trim());
				}

				if (itemDetalhe.CedenteCPFCNPJ !== undefined) {
					detail.assignorCpfCnpj = CP.transform((itemDetalhe.CedenteCPFCNPJ).trim());
				}

				detail.code = item.Codigo;
				detail.complement = item.Complemento;
				detail.autentication = item.Autenticacao;
				detail.favName = itemDetalhe.FavNome;
				detail.favBank = itemDetalhe.FavBanco;
				detail.favAgency = itemDetalhe.FavAgencia;
				detail.favNumberAccount = itemDetalhe.FavNroConta;
				detail.favTypeAccount = itemDetalhe.FavTpConta;
				detail.finalitySPB = itemDetalhe.FinalidadeSPB;
				detail.historic = itemDetalhe.Historico;
				detail.finalityTes = itemDetalhe.FinalidadeTes;
				detail.finalityCompe = itemDetalhe.FinalidadeCompe;
				detail.nameAgreement = itemDetalhe.NmConveniada;
				detail.assignorName = itemDetalhe.CedenteNome;

				if (detail.receiptsTitle === undefined) {
					detail.hasFirstRow = false;
				}

				if (detail.code === 5) {
					detail.isSecuritie = true;
				}

				detail.payerName = Auth.getInstance().getUser().name;
				detail.payerCpfCnpj = this.myDocument
				detail.payerAgency = Auth.getInstance().getUser().agency;
				detail.payerAccount = ANP.transform(Auth.getInstance().getUser().accountNumber);

				detail.securitieRebateValue = FP.transform(itemDetalhe.Abatimento, false);
				detail.discountValue = FP.transform(itemDetalhe.Desconto, false);
				detail.taxValue = FP.transform(itemDetalhe.Juros, false);
				detail.fineValue = FP.transform(itemDetalhe.Multa, false);
				detail.chargesValue = FP.transform(itemDetalhe.Encargos, false);
				detail.nominalValue = FP.transform(itemDetalhe.ValorDocumento, false);

				if (
					detail.favName === undefined &&
					detail.favCpfCnpj === undefined &&
					detail.assignorName === undefined &&
					detail.assignorCpfCnpj === undefined &&
					detail.favBankDescription === undefined &&
					detail.favBank === undefined &&
					detail.favAgency === undefined &&
					detail.codeBar === undefined &&
					detail.dueDate === undefined &&
					detail.favNumberAccount === undefined &&
					detail.favTypeAccount === undefined &&
					detail.debitDate === undefined &&
					detail.dateTimeTransaction === undefined &&
					detail.number === undefined &&
					detail.value === undefined &&
					detail.complement === undefined) {
					detail.hasSecondRow = false;
				}

				if (detail.autentication === undefined) {
						detail.hasThirdRow = false;
				}
			}

			this.setSelectedReceipt(detail);

			return detail;
		}));
	}

	getReceiptDetailsTransfer(_typeReceipt: any, data: any): Detail {
		const detail = new Detail();
		const FP = new FormatPricePipe();
		const CP = new CpfCnpjPipe();
		const ANP = new AccountNumberPipe();
		const item = data.Retorno;
		const itemDetalhe = item.TransacaoTransferencia;

		detail.transactionId = item.CodigoTransacao;
		detail.transactionType = item.TipoTransacao;
		detail.debitDate = moment(item.DataContabil).format("DD/MM/YYYY");
		detail.dateTimeTransaction = moment(item.DataTransacao).format("DD/MM/YYYY [às] HH:mm:ss");
		detail.value = FP.transform(item.Valor, false);
		detail.favCpfCnpj = Util.maskCpfCnpjPix(itemDetalhe.Documento);
		detail.favName = itemDetalhe.Nome;
		detail.favBankDescription = itemDetalhe.NomeISPB;
		detail.favAgency = itemDetalhe.Agencia;
		detail.favNumberAccount = itemDetalhe.NumeroConta;
		detail.favTypeAccount = itemDetalhe.TipoConta;
		

		detail.payerName = Auth.getInstance().getUser().name;
		detail.payerCpfCnpj = Util.maskCpfCnpjPix(this.myDocument);
		detail.payerAgency = Auth.getInstance().getUser().agency;
		detail.payerAccount = ANP.transform(Auth.getInstance().getUser().accountNumber);

		detail.receiptsTitle = "Comprovante de transferência";
		detail.receiptsSubtitle = "Dados da transferência";

		return detail;
	}

	private getReceiptDetailsPix(data: any, typeReceipt: any) {
			let detail: Detail = new Detail();;
			const user = Auth.getInstance().getUser();
			const item = data.Retorno;
			const FP = new FormatPricePipe();

			const transacaoPix = data.Retorno.TransacaoPix;
			const tipoMovimentacao = data.Retorno.TipoMovimentacao;

			const emitBankDescription = tipoMovimentacao === 'C' ? transacaoPix.NomeISPB : 'Omni Banco S.A.';
			const emitAgency = tipoMovimentacao === 'C' ? transacaoPix.Agencia : user.agency;
			const emitNumberAccount = tipoMovimentacao === 'C' ? transacaoPix.NumeroConta : user.accountNumber;
			const emitName = tipoMovimentacao === 'C' ? transacaoPix.Nome : user.name;
			const emitCpfCnpj = tipoMovimentacao === 'C' ? transacaoPix.Documento : user.cpfCnpj;

			const favBankDescription = tipoMovimentacao !== 'C' ? transacaoPix.NomeISPB : 'Omni Banco S.A.';
			const favAgency = tipoMovimentacao !== 'C' ? transacaoPix.Agencia : user.agency;
			const favNumberAccount = tipoMovimentacao !== 'C' ? transacaoPix.NumeroConta : user.accountNumber;
			const favName = tipoMovimentacao !== 'C' ? transacaoPix.Nome : user.name;
			const favCpfCnpj = tipoMovimentacao !== 'C' ? transacaoPix.Documento : user.cpfCnpj;

			detail.receiptsTitle = typeReceipt === 'PIXDevolvido' ? 'Comprovante de devolução' : 'Comprovante de transferência';
			detail.receiptsSubtitle = typeReceipt === 'PIXDevolvido' ? 'Dados da devolução' : 'Dados da transferência';
			detail.complement = transacaoPix.Complemento;
			detail.endToEndId = transacaoPix.CodigoFimAFim;
			detail.transactionId = item.CodigoTransacao;

			if (item.DataTransacao !== undefined) {
				detail.debitDate = moment(item.DataTransacao).format('DD/MM/YYYY HH:mm');
			}

			if (item.Valor !== undefined) {
				detail.value = FP.transform(item.Valor, false);
			}

			detail.transferEmitBankDescription = emitBankDescription.toUpperCase();
			detail.transferEmitAgency = emitAgency;
			detail.transferEmitNumberAccount = emitNumberAccount;
			detail.transferEmitName = emitName.toUpperCase();

			if (emitCpfCnpj !== undefined) {
				detail.transferEmitCpfCnpj = Util.maskCpfCnpjPix(emitCpfCnpj);
			}

			detail.favBankDescription = favBankDescription.toUpperCase();
			detail.favAgency = favAgency;
			detail.favNumberAccount = favNumberAccount;
			detail.favName = favName.toUpperCase();

			if (favCpfCnpj !== undefined) {
				detail.favCpfCnpj = Util.maskCpfCnpjPix(favCpfCnpj);
			}

			if (typeReceipt === 'PIXDevolvido') {
				detail.endToEndId = transacaoPix.CodigoFimAFimDevolucao;

				const transacaoOriginal = transacaoPix.TransacaoOriginal;
				detail.complementTransactionOrig = transacaoOriginal.Descricao;

				if (transacaoOriginal.Valor !== undefined) {
					detail.valueTransactionOrig = FP.transform(transacaoOriginal.Valor, false);
				}

				if (transacaoOriginal.DataTransacao !== undefined) {
					detail.dateTimeTransactionOrig = moment(transacaoOriginal.DataTransacao).format('DD/MM/YYYY HH:mm');
				}
			}
		return detail;
	}

	getReceiptDetailsConvenioBankSlip(typeReceipt: any, data: any): Detail {
		let detail = new Detail();
		let itemDetalhe;

		const FP = new FormatPricePipe();
		const ANP = new AccountNumberPipe();
		const item = data.Retorno;

		if (item.DataTransacao !== undefined) {
		  detail.dateTimeTransaction = moment(
			item.DataTransacao
		  ).format("DD/MM/YYYY [às] HH:mm:ss");
		}

		itemDetalhe = data.Retorno.TransacaoConvenio;
		detail.receiptsTitle = "Comprovante de pagamento";
		detail.autentication = itemDetalhe.Autenticacao;
		detail.favName = itemDetalhe.EmpresaOrgao;
		detail.debitDate = moment(item.DataContabil).format("DD/MM/YYYY");
		detail.codeBar = itemDetalhe.CodigoBarrasConsumo;
		detail.transactionId = item.CodigoTransacao;
		detail.value = FP.transform(item.Valor, false);

		detail.payerName = Auth.getInstance().getUser().name;
		detail.payerCpfCnpj = Util.maskCpfCnpjPix(this.myDocument)

		detail.payerAgency = Auth.getInstance().getUser().agency;
		detail.payerAccount = ANP.transform(
		  Auth.getInstance().getUser().accountNumber
		);

		return detail;
	  }

	getReceiptDetailsBankSlip(typeReceipt: any, data: any): Detail {
		let detail = new Detail();
		let itemDetalhe;

		const FP = new FormatPricePipe();
		const CP = new CpfCnpjPipe();
		const ANP = new AccountNumberPipe();
		const item = data.Retorno;

		if (item.DataTransacao !== undefined) {
		  detail.dateTimeTransaction = moment(
			item.DataTransacao
		  ).format("DD/MM/YYYY [às] HH:mm:ss");
		}

		itemDetalhe = data.Retorno.TransacaoBoleto;
		detail.receiptsTitle = "Comprovante de pagamento";
		detail.autentication = itemDetalhe.Autenticacao;
		detail.favName = itemDetalhe.NomeBeneficiario;
		detail.favCpfCnpj = Util.maskCpfCnpjPix(itemDetalhe.DocumentoBeneficiario);
		detail.debitDate = moment(item.DataContabil).format("DD/MM/YYYY");
		detail.codeBar = itemDetalhe.LinhaDigitavel;
		detail.transactionId = item.CodigoTransacao;
		detail.value = FP.transform(item.Valor, false);
		detail.valueTransactionOrig = FP.transform(itemDetalhe.ValorDocumento)

		detail.payerName = Auth.getInstance().getUser().name;
		detail.payerCpfCnpj = Util.maskCpfCnpjPix(this.myDocument)

		detail.payerAgency = Auth.getInstance().getUser().agency;
		detail.payerAccount = ANP.transform(
		  Auth.getInstance().getUser().accountNumber
		);

		return detail;
	  }

	get myDocument(){
		return Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;
	}

	getReceiptPdf(receiptId: number, receiptType: string, fileType: string): Observable<any> {
		return this.http.get(endpoints.receipts.all + `/
			${receiptId}/
			${receiptType}/
			${fileType}/
			download`, {
			}).pipe(map((data: any) => {
				return data.Retorno;
			}));
	}

	getSelectedReceipt = () => this.selectedReceipt;

	setSelectedReceipt = (receipt: Detail) => this.selectedReceipt = receipt;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/receipts.service.ts